<template>
  <div class="hl-policy-box">
    <strong>开源生态</strong>
    <p>围绕开源项目打造的生态社区，汇集最新最全的IoT政策与资讯</p>
    <div>
      <div class="hl-policy-content">
        <div class="hl-policy-content-tag">
          <div>
            <span :class="{ active: policyIdx === 0 }" @click="policyIdx = 0"
              >政策资讯</span
            >
            <span :class="{ active: policyIdx === 1 }" @click="policyIdx = 1"
              >开源专区</span
            >
          </div>
        </div>
        <div class="hl-policy-list">
          <a-divider type="vertical" class="hl-policy-divider" />
          <div class="hl-policy-list-all" v-if="policyIdx === 0">
            <div
              v-for="el in policyList"
              :key="el.id"
              @click="$router.push(`/policy/info?id=${el.id}`)"
            >
              <p>
                <span v-if="el.newsTypeName">{{ el.newsTypeName }}</span>
                {{ el.newsName }}
              </p>
              <span v-html="el.summary"></span>
            </div>
          </div>
          <div class="hl-policy-list-all" v-else>
            <div
              v-for="el in openList"
              :key="el.id"
              @click="openUrl(el.sourceUrl)"
            >
              <p>
                <span>{{ el.newsCategory.split(",")[0] }}</span>
                {{ el.newsTitle }}
              </p>
              <span v-html="el.summary"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="hl-policy-example">
        <p>开源项目</p>
        <div>
          <div
            v-for="(el, idx) in openProject"
            :key="idx"
            :class="{ active: idx === openProjectIdx }"
            @mouseover="openProjectIdx = idx"
            @click="openUrl(el.sourceUrl)"
          >
            <div class="hl-policy-example-title">
              <span>
                <v-img
                  :attachment-id="el.projectIcon"
                  :default-img="require('@/assets/img/kctp.png')"
                />
              </span>
              <div>
                <p>{{ el.projectCategory }} - {{ el.projectName }}</p>
                <!-- <span><a-icon type="clock-circle" />{{ el.date }}发布</span> -->
              </div>
            </div>
            <div class="hl-policy-example-desc">
              <span>
                {{ el.projectDescription }}
              </span>
              <!-- <p><a-icon type="clock-circle" />{{ el.date }}发布</p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsList, getOpenNewsCondition } from "@/api/news";
import { getOpenProjectList } from "@/api/openKnowledge";
import VImg from "@/components/VImg";
export default {
  components: {
    VImg,
  },
  data() {
    return {
      policyIdx: 0,
      policyType: 0,
      page: {
        current: 1,
        size: 12,
      },
      policyList: [],
      openList: [],
      openProjectIdx: 0,
      openProject: [
        {
          title: "Websoft9 - 多应用托管平台",
          desc: "Websoft9（微聚云） 是一个创新的、企业级的多应用托管平台，它的目标是让任何类型的应用程序稳定的运行在客户的云设施中。",
          img: require("@/assets/img/project/websoft9_fhQzj.png"),
          url: "https://portal.mulanos.cn/p/websoft9",
          date: "2024/06/01",
        },
        {
          title: "Kubean - 集群生命周期管理工具",
          desc: "Kubean 是一款准生产的集群生命周期管理工具，基于 kubespray 与其他集群 LCM 引擎。",
          img: require("@/assets/img/project/kubean_TyrTz.png"),
          url: "https://portal.mulanos.cn/p/kubean",
          date: "2024/04/01",
        },
        {
          title: "blazork8s - Kubernetes 管理工具",
          desc: "使用C# Blazor 编写的Kubernetes管理工具，集成了ChatGPT类大模型，用简单易用的操作界面，提升k8s管理效率。",
          img: require("@/assets/img/project/blazork8s_Z9MrX.png"),
          url: "https://portal.mulanos.cn/p/blazork8s",
          date: "2024/03/11",
        },
        {
          title: "SingularityCE - Singularity 的社区版",
          desc: "SingularityCE 是 Singularity 的社区版，Singularity 是一个开源容器平台，旨在简单、快速和安全。",
          img: require("@/assets/img/project/singularityce_sfhwl.png"),
          url: "https://portal.mulanos.cn/p/singularityce",
          date: "2024/03/01",
        },
        {
          title: "k0smotron - 统一 Kubernetes 集群管理",
          desc: "k0smotron 是一个用于统一集群管理的开源控制平面管理器。允许用户统一 Kubernetes 集群管理，以高效利用资源。",
          img: require("@/assets/img/project/k0smotron_FIJ5R.png"),
          url: "https://portal.mulanos.cn/p/k0smotron",
          date: "2024/02/21",
        },
      ],
    };
  },
  mounted() {
    this.loadGetNewsList();
    this.loadOpenList();
    this.openProjectList();
  },
  methods: {
    openUrl(url) {
      if (url) {
        window.open(url);
      }
    },
    loadGetNewsList() {
      getNewsList(this.page, {}).then((res) => {
        this.policyList = res.records;
      });
    },
    loadOpenList() {
      getOpenNewsCondition(this.page, {}).then((res) => {
        this.openList = res.records;
      });
    },
    openProjectList() {
      getOpenProjectList(
        { current: 1, size: 5 },
        {
          projectCategory: null,
        }
      ).then((res) => {
        console.log(res);
        this.openProject = res.records;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.hl-policy-box {
  padding: 64px 0;
  background: url(../../assets/img/2.0/kyzixbg.png) no-repeat;
  background-size: 100% 100%;
  > strong {
    display: block;
    font-size: 32px;
    line-height: 45px;
    color: #262626;
    text-align: center;
    margin-bottom: 16px;
  }
  > p {
    font-size: 18px;
    color: #000000;
    line-height: 28px;
    margin-bottom: 48px;
    text-align: center;
  }
  > div {
    width: 1280px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .hl-policy-content {
      width: 936px;
      height: 622px;
      background: #fff;
      .hl-policy-content-tag {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #e8e8e8;
        padding: 0 24px;
        height: 70px;
        > div {
          display: flex;
          height: 100%;
          > span {
            height: 100%;
            display: flex;
            align-items: center;
            margin-right: 40px;
            cursor: pointer;
            border-bottom: 2px solid transparent;
            font-size: 16px;
            color: #262626;
            &:last-child {
              margin-right: 0;
            }
            &.active {
              border-color: #ea0b06;
              color: #ea0b06;
            }
          }
        }
        > p {
          > span {
            cursor: pointer;
            font-size: 14px;
            color: #666666;
            line-height: 20px;
            &.active {
              color: #ea0b06;
            }
          }
        }
      }
      .hl-policy-list {
        padding: 24px 0;
        // display: flex;
        // flex-wrap: wrap;
        // justify-content: space-between;
        position: relative;
        height: calc(100% - 70px);
        .hl-policy-divider {
          position: absolute;
          left: 50%;
          width: 1px;
          background: #e8e8e8;
          top: 24px;
          bottom: 24px;
          padding: 0;
          height: auto;
        }
        .hl-policy-list-all {
          overflow: hidden;
          > div {
            width: 440px;
            padding: 16px 24px;
            height: 84px;
            cursor: pointer;
            float: left;
            &:nth-child(2n) {
              float: right;
            }
            > p {
              font-size: 16px;
              color: #262626;
              line-height: 24px;
              margin-bottom: 12px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              transition: all 0.3s;
              > span {
                float: left;
                margin-right: 8px;
                height: 22px;
                border: 1px solid #ea0b06;
                padding: 0 8px;
                line-height: 20px;
                font-size: 12px;
                color: #ea0b06;
              }
            }
            > span {
              display: block;
              font-size: 12px;
              color: #999999;
              line-height: 16px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              height: 16px;
              overflow: hidden;
              ::v-deep > img {
                max-width: 100%;
              }
            }
            &:hover {
              > p {
                color: #ea0b06;
              }
            }
          }
        }
      }
    }
    .hl-policy-example {
      width: 320px;
      background: url(../../assets/img/2.0/kyxmbg.png) no-repeat;
      background-size: 100% 100%;
      padding: 24px 24px 0;
      > p {
        font-weight: bold;
        font-size: 16px;
        color: #262626;
        line-height: 22px;
      }
      > div {
        > div {
          padding: 24px 0;
          border-bottom: 1px solid #ffffff;
          cursor: pointer;
          &:last-child {
            border-bottom: 0;
          }
          .hl-policy-example-title {
            display: flex;
            align-items: center;
            > span {
              width: 48px;
              height: 48px;
              margin-right: 12px;
              > img {
                display: block;
                max-width: 100%;
                max-height: 100%;
              }
            }
            > div {
              flex: 1;
              > p {
                display: flex;
                align-items: center;
                font-weight: bold;
                font-size: 18px;
                color: #262626;
                line-height: 24px;
              }
              > span {
                display: none;
                margin-top: 8px;
                align-items: center;
                font-size: 12px;
                color: #999999;
                line-height: 16px;
                > i {
                  margin-right: 8px;
                }
              }
            }
          }
          .hl-policy-example-desc {
            display: none;
            margin-top: 12px;
            > span {
              display: block;
              font-size: 14px;
              color: #666666;
              line-height: 24px;
              margin-bottom: 12px;

              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }
            > p {
              display: flex;
              align-items: center;
              font-size: 14px;
              color: #999999;
              line-height: 20px;
              > i {
                margin-right: 8px;
              }
            }
          }
          &.active {
            .hl-policy-example-desc {
              display: block;
            }
          }
        }
      }
    }
  }
}
</style>
